import { Component, Input, OnInit } from '@angular/core';

import { Item } from './items/item';
import { ItemsService } from './items/items.service';

@Component({
  selector: 'app-transition-matrix',
  templateUrl: './transition-matrix.component.html',
  styleUrls: ['./transition-matrix.component.css']
})
export class TransitionMatrixComponent implements OnInit {

  @Input() onShowPeriod;
  @Input() onFlexGrid;
  @Input() onEdit;
  

  items: Item [];
  mockItems: Item [] = [];

  constructor(
    private _itemsService: ItemsService) {}

    getItems(): void {
    this._itemsService.getItems().then(items => this.items = items);
  }

  getMockItems(): void {
    this._itemsService.getMockItems().then(mockItems => this.mockItems = mockItems);
  }

  ngOnInit(): void {
    this.getMockItems();
    this.getItems();
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/transition-matrix/transition-matrix.component.ts